<template>
  <draggable-box :stopPosition="stopPosition" :initX="initX" :initY="initY">
    <span :class="[startScroll ? 'hide' : 'animate__backInRight']"
      ><slot></slot
    ></span>
  </draggable-box>
</template>
<script>
  import DraggableBox from '@/components/DraggableBox'

  export default {
    props: {
      stopPosition: {
        type: String,
        default: 'right',
      },
      initX: {
        type: Number,
        default: 16,
      },
      initY: {
        type: Number,
        default: 120,
      },
    },
    data() {
      return {
        preScrollTop: 0,
        scrollTop: 0,
        startScroll: false,
      }
    },
    components: {
      DraggableBox,
    },
    watch: {
      scrollTop(newVal, oldVal) {
        const timeid = setTimeout(() => {
          if (newVal === window.scrollY) {
            this.startScroll = false
            this.preScrollTop = newVal
          }
          clearTimeout(timeid)
        }, 20)
        if (this.preScrollTop === oldVal) {
          this.startScroll = true
        }
      },
    },
    created() {
      if (!process.client) {
        return
      }
      window.addEventListener('scroll', this.scroll, true)
    },
    methods: {
      scroll() {
        this.scrollTop = window.scrollY
      },
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scroll)
    },
  }
</script>
<style lang="scss" scoped>
  .animate__backInRight {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-name: backInRight;
    animation-name: backInRight;
  }

  @keyframes backInRight {
    0% {
      -webkit-transform: translateX(2000px) scale(0.7);
      transform: translateX(2000px) scale(0.7);
      opacity: 0.7;
    }

    80% {
      -webkit-transform: translateX(0px) scale(0.7);
      transform: translateX(0px) scale(0.7);
      opacity: 0.7;
    }

    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 1;
    }
  }

  .animate__bounceInRight {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-name: bounceInRight;
    animation-name: bounceInRight;
  }

  @keyframes bounceInRight {
    from,
    60%,
    75%,
    90%,
    to {
      -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    from {
      opacity: 0;
      -webkit-transform: translate3d(3000px, 0, 0) scaleX(3);
      transform: translate3d(3000px, 0, 0) scaleX(3);
    }

    60% {
      opacity: 1;
      -webkit-transform: translate3d(-25px, 0, 0) scaleX(1);
      transform: translate3d(-25px, 0, 0) scaleX(1);
    }

    75% {
      -webkit-transform: translate3d(10px, 0, 0) scaleX(0.98);
      transform: translate3d(10px, 0, 0) scaleX(0.98);
    }

    90% {
      -webkit-transform: translate3d(-5px, 0, 0) scaleX(0.995);
      transform: translate3d(-5px, 0, 0) scaleX(0.995);
    }

    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }
</style>
